angular.module("core")

.directive("zoomableImage",  function() {
    return {
        restrict : "A",
        templateUrl: require("./zoomable-image.directive.html"),
        scope: true,
        bindToController: {
            image: "<zoomableImage",
            name: "<zoomableImageName"
        },
        controller: zoomableImageController,
        controllerAs: "zoomableImageCtrl"
    }
});

function zoomableImageController(ModalService) {

    this.hasImage = function() {
        return this.image && this.image.full_size && this.image.details;
    };

    this.openModal = function() {
        if (this.hasImage()) {
            ModalService.showModal({
                templateUrl: require("./zoomable-image.modal.html"),
                controller: "zoomableImageModalController",
                controllerAs: "zoomableImageModalCtrl",
                inputs: {
                    $attrs: {
                        image: this.image,
                        title: this.name
                    }
                }
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
            });
        }
    };
}



//////////////////
// WEBPACK FOOTER
// ./core/zoomable-image/zoomable-image.directive.js
// module id = 490
// module chunks = 0